import { path } from 'ramda';

import { getAllQueryParams } from '../query';

import config from '../../generated/config';

const brandDomain = path(['cookieDomain'], config);

const safeBrandDomain = brandDomain.replace(/\./g, '\\.');

const { origin } = getAllQueryParams();

const USER_AUTHENTICATION_SUCCESSFULY = 'USER_AUTHENTICATION_SUCCESSFULY';

const USER_AUTHENTICATION_FAILED = 'USER_AUTHENTICATION_FAILED';

const successfulyMessage = () => ({
  type: USER_AUTHENTICATION_SUCCESSFULY,
  success: true
});

const failMessage = ({ message }) => ({
  type: USER_AUTHENTICATION_FAILED,
  success: false,
  error: message
});

const isValidOrigin = originUrl => {
  try {
    const matchValidDomain = new RegExp(`^(https?:\\/\\/)([^.]+\\.)?[^.]+${safeBrandDomain}`, 'i');
    const match = matchValidDomain.exec(originUrl);
    return match !== null;
  } catch (error) {
    return false;
  }
};

const send = message => {
  if (window.self !== window.top) {
    try {
      if (isValidOrigin(origin)) {
        window.parent.postMessage(message, origin);
        console.log(`post-message [send]`, { message });
      } else {
        console.error(`post-message in send, invalid domain [${origin}]`);
      }
    } catch (error) {
      console.error(`error on post-message`, { error });
      return false;
    }
  }
};

export const startListener = listenerCallback => {
  try {
    window.addEventListener('message', listenerCallback, false);
  } catch (error) {
    console.error(`post-message in listen`, { error });
  }
};

export const sendSuccessfulyMessage = () => send(successfulyMessage());

export const sendFailMessage = error => send(failMessage(error));
